export const mutations = {
  addTarif (state, tarif) {
    state.tarif = tarif
  },
  setTarif (state, tarif) {
    state.tarif = tarif
  },
    addTarifs(state, tarif){
    state.tarifs = [ ...tarif ]
  },
  addTarifsPage(state, tarif){
    state.tarifs = tarif
  },
}
